import InteractiveDiagram from './InteractiveDiagram';
import DragAndDrop from './DragAndDrop';
import StepByStep from './StepByStep';

/**
 * SimulationRenderer - Renders the appropriate simulation component based on type
 */
export default function SimulationRenderer({ simulationType, simulationData, onComplete }) {
  switch (simulationType) {
    case 'interactive_diagram':
      return (
        <InteractiveDiagram
          simulationData={simulationData}
          onComplete={onComplete}
        />
      );
    
    case 'drag_and_drop':
      return (
        <DragAndDrop
          simulationData={simulationData}
          onComplete={onComplete}
        />
      );
    
    case 'step_by_step':
      return (
        <StepByStep
          simulationData={simulationData}
          onComplete={onComplete}
        />
      );
    
    case 'interactive_quiz':
      // TODO: Implement InteractiveQuiz component
      return (
        <div className="text-center py-8">
          <p className="text-gray-500">Interactive Quiz simulation coming soon!</p>
        </div>
      );
    
    case 'virtual_experiment':
      // TODO: Implement VirtualExperiment component
      return (
        <div className="text-center py-8">
          <p className="text-gray-500">Virtual Experiment simulation coming soon!</p>
        </div>
      );
    
    default:
      return (
        <div className="text-center py-8">
          <p className="text-red-500">Unknown simulation type: {simulationType}</p>
        </div>
      );
  }
}


